import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../../assets/style-helpers.scss';

export const templateEditLicensingOptionsMenu = document.createElement('template');

templateEditLicensingOptionsMenu.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div id='licensing-options-wrapper'>
    <div id='licensing-options-inner-container'>
      <gz-license-main-form></gz-license-main-form>
      <div style='flex: auto;'></div>
    </div>
    <div class='bottom-buttons'>
        <gz-button id='save-button' disabled></gz-button>
        <gz-button type='outline' color='secondary' id='cancel-button'></gz-button>
    </div>
  </div>
`;
